

import Accounts from "./Accounts";


class Assignment extends Accounts{
    constructor(params) {
      super(params);
    
    this.accountLabel = "Assignment";
    this.accountType = "Assignment";
    this.variables = [{}];
  this.setParameters(params);
  //params.updateTree(this);
    }
  
    setParameters(params){
      for (var prop in params){
          if (params.hasOwnProperty(prop)){
              var method = "set" + prop.charAt(0).toUpperCase() + prop.slice(1);
              if (this[method]){
                  this[method](params[prop]);
              }
              
          }
      }
    }
    setVariableName(val){
      this.variableName = val;
      this.variables[0].key = val;
      
    }
    setDisplayLabel(val){
      this.displayLabel = val;
      this.variables[0].label = val;
       
    }
    setValue(val){
      this.value = val;
      this.variables[0].value = val;
      this.parentValue = val
    }
    setAccesses(arr){
      this.access = arr;
    }
    setElement(o){
      this.parent = false;
       this.elementId = o.documentId;
       this.parentProperty = o.variableName;
       this.parentLabel = o.displayName;
       if (o.element){
        this.parent = o.element.documentId;
       }
    }
    addAssignment(o){
      this.Assignment = this.Assignment ? this.Assignment : [];
      this.Assignment.push(o);
    }
    
    
}

export default Assignment;
  